import React from 'react'
import _ from 'lodash'

import { AboutBlock } from '../Blocks'

import audit1 from '../../assets/images/audit/consultant.png'


const AuditOne = ({ lang }) => {
  const isEn = lang === 'en';

  const AboutBlocks = [
    {
      rootProps: { className: 'tile row' },
      image: { rootProps: { className: 'col-6 col-12-medium image' }, image: audit1 },
      textGroup: {
        rootProps: { className: 'text-group col-6 col-12-medium' },
        title: {
          type: 'h1',
          text:
            isEn ? 'Obtenha 1 hora de Auditoria Grátis!' : 'Obtenha 1 hora de Auditoria Grátis!',
        },
        description: {
          text:
            isEn ? "Descubra como otimizar o desempenho, a segurança e a escalabilidade do seu site WordPress." : "Descubra como otimizar o desempenho, a segurança e a escalabilidade do seu site WordPress.",
        },
        cta: {
            rootProps: {
              className: 'button audit-btn audit-anchor-link gethelp-one',
              to: isEn ? '#' : '#',
            },
            text: isEn ? "Let's talk" : 'Obtenha a nossa ajuda',
        },
      },
    },
  ]

  return (
    <section id="about-two">
      <div className="content container">
        <div className="row">
          {_.map(AboutBlocks, (block, i) => (
            <React.Fragment key={`about-block-${i}`}>
              <AboutBlock rev={i % 2} {...block} />
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  )
}
export default AuditOne
